import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=4abd0016&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=4abd0016&prod&scoped=true&lang=css"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=4abd0016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd0016",
  null
  
)

export default component.exports